import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { VznFeathersService } from '@noammazuz/vzn-feathers';
import { Site } from 'src/app/models/site';
import { ServiceMethods } from '@feathersjs/feathers';
import { TableColumn } from '@noammazuz/vzn-data-table';
import { Router } from '@angular/router';
import { TranslateService, TranslationChangeEvent } from '@ngx-translate/core';


@Component({
  selector: 'app-sites-page',
  templateUrl: './sites-page.component.html',
  styleUrls: ['./sites-page.component.scss']
})
export class SitesPageComponent implements OnInit {
  @ViewChild('previewButtonTmpl', { static: true }) previewButtonTmpl: ElementRef<any>;
  siteService: ServiceMethods<Site>;
  query: any = {
    $sort: {
      createdAt: -1
    }
  };
  columns: TableColumn[];
  constructor(
    public translate: TranslateService,
    private feathers: VznFeathersService<Site>,
    private router: Router
  ) {
    this.translate = translate;
    this.siteService = this.feathers.service('sites');
  }


  ngOnInit(): void {
    this.columns = [
      { prop: 'name', name: this.translate.instant('SITE-DETAILS-PAGE.NAME'), filterType: 'like', cellTemplate: 'textTmpl' },
      { prop: 'dateTitle', name: this.translate.instant('SITE-PAGE.DATE-TITLE'), filterType: 'like', cellTemplate: 'textTmpl' },
      { prop: 'date1', name: this.translate.instant('SITE-PAGE.DATE1'), filterType: 'like', cellTemplate: 'dateNoTimeTmpl' },
      { prop: 'date2', name: this.translate.instant('SITE-PAGE.DATE2'), filterType: 'like', cellTemplate: 'dateNoTimeTmpl' },
      { prop: 'date3', name: this.translate.instant('SITE-PAGE.DATE3'), filterType: 'like', cellTemplate: 'dateNoTimeTmpl' },
      { prop: 'logo', name: this.translate.instant('SITE-PAGE.LOGO'), cellTemplate: 'vznMediaTmpl' },
      { prop: 'bgImage', name: this.translate.instant('SITE-PAGE.BG-IMG'), cellTemplate: 'vznMediaTmpl' },
      { prop: 'contentImage', name: this.translate.instant('SITE-PAGE.CONTENT-IMG'), cellTemplate: 'vznMediaTmpl' },
      { prop: 'preview', name: this.translate.instant('SITE-PAGE.PREVIEW'), customTemplate: this.previewButtonTmpl }
 ];
  }

  onDoubleClick(site: Site) {
    this.router.navigate([`/site-details/${site._id}`])
  }

  siteMapper(rows: any[]) {
    return rows.map((row: any) => new Site(row));
  }
}
